<template>
  <section class="lb-portal">
    <div class="lb-breadcrumb">
      <div class="container row">
        <div class="large-12 column">
          <div v-if="!mediaQueries.isSmallOnly">
            <span v-for="element in options.BreadcrumbElements" :key="element.Text">
              <a :href="element.Url" v-html="element.Text" />
              <span class="margin-lr" v-text="'>'" />
            </span>
            <span>
              <a class="disablelink" v-html="options.CurrentPageElement.Text" />
            </span>
          </div>
          <div v-if="mediaQueries.isSmallOnly && options.hasOwnProperty('BreadcrumbElements')">
            <span class="margin-r" v-text="'<'" />
            <a
              :href="options.BreadcrumbElements[options.BreadcrumbElements.length - 1].Url"
              v-html="options.BreadcrumbElements[options.BreadcrumbElements.length - 1].Text"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import BaseMixin from '@/components/Feature/BaseMixin.vue';

export default {
  name: 'Breadcrumb',
  mixins: [BaseMixin],
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};
</script>
<style type="scss" scoped>
a {
  text-decoration: none;
}

.margin-lr {
  margin: 0 5px;
}

.margin-r {
  margin-right: 5px;
}

.lb-breadcrumb {
  padding: 30px 0;
}
</style>
